<template>
  <div class="driver-stat-card">
    <div
      class="driver-stat-card__icon"
      :class="{ 'driver-stat-card__icon--composite': composite }"
      :style="{ width: `${boxWidth}px`, height: `${boxHeight}px` }"
    >
      <img
        :src="iconSrc"
        :alt="label"
        :width="iconWidth"
        :height="iconHeight"
        class="driver-stat-card__glyph"
      >
    </div>
    <div class="driver-stat-card__content">
      <div class="driver-stat-card__label">
        {{ label }}
      </div>
      <div class="driver-stat-card__value">
        {{ value }}
      </div>
      <div
        v-if="hint"
        class="driver-stat-card__hint"
      >
        {{ hint }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    hint: {
      type: String,
      default: ''
    },
    composite: {
      type: Boolean,
      default: false
    },
    iconWidth: {
      type: Number,
      default: 48
    },
    iconHeight: {
      type: Number,
      default: 48
    },
    boxWidth: {
      type: Number,
      default: 64
    },
    boxHeight: {
      type: Number,
      default: 64
    }
  },
  computed: {
    iconSrc () {
      return require(`../../assets/icons/driver-settlements/${this.icon}.svg`)
    }
  }
}
</script>
